var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 14.914,
    viewBox: "0 0 16 14.914",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14.914,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_star",
    "data-name": "Icon - star",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M35.255,4.973l-4.247-.619L29.11.505a.931.931,0,0,0-1.669,0l-1.9,3.849L21.3,4.973a.931.931,0,0,0-.515,1.587l3.073,2.994-.727,4.23a.93.93,0,0,0,1.349.98l3.8-2,3.8,2a.93.93,0,0,0,1.349-.98L32.7,9.554,35.77,6.56a.931.931,0,0,0-.515-1.587ZM31.7,9.229l.808,4.709-4.232-2.221-4.23,2.224.808-4.709L21.43,5.892l4.73-.686L28.276.918l2.116,4.288,4.73.686Z",
    transform: "translate(-20.5 0.013)",
    fill: "#1a1a1a"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - star.fff1f4ed5d561cbd65eed9208fd25ba7.svg";